'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/fobclient/~/axios/lib/cancel/isCancel.js
// module id = UslH
// module chunks = 0